// extracted by mini-css-extract-plugin
export default {"headline_and_btn_box":"CreditStyles_headline_and_btn_box__rkOON","img-full-width":"CreditStyles_img-full-width__sdoK-","img-half-width":"CreditStyles_img-half-width__-s2Ir"};